var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"500","content-class":"rounded-xl"},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',[_c('v-card-title',[_vm._v("Form Change Request Instruction")]),_c('v-card-text',[_vm._v(" HELP!!! ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }